import {h, Component} from 'preact';
import { compileMessage } from "@lingui/message-utils/compileMessage";
import { i18n } from "@lingui/core";
import { I18nProvider } from '@lingui/react';
import Config from "../config";

/* Ogni lingua va importata qui */
import { messages as messages_IT } from "../../../../langs/it/messages";
import { messages as messages_EN } from "../../../../langs/en/messages";
import { messages as messages_ES } from "../../../../langs/es/messages";

const catalogs = {
    it: messages_IT,
    en: messages_EN,
    es: messages_ES
};
Object.keys(catalogs).forEach(lang => {
    i18n.load(lang, catalogs[lang]);
});
// che cazzo è????
i18n.setMessagesCompiler(compileMessage)

class Localization extends Component {
    static instance = null;
    static data = {
        defaultLanguage: Config.defaultLanguage,
        currentLanguage: Config.lang || Config.defaultLanguage
    }

    componentWillMount() {
        Localization.instance = this;
        window.i18n = i18n;
        window.Translation = (data) => i18n._(data);

        let initialLang = Localization.data.defaultLanguage;
        
        /*
         * Selezione lingua tramite url
         */
        if (!!window.location.search) {
            const urlParams = new URLSearchParams(window.location.search);

            if (urlParams.has('lang') && !!catalogs[urlParams.get('lang')]) {
                initialLang = urlParams.get('lang');
                Localization.data.currentLanguage = initialLang;
                Config.lang = initialLang;
            }
        }

        i18n.activate(Localization.data.currentLanguage);
    }

    static useTranslations(language) {
        if (!catalogs[language])
            return;
        Localization.data.currentLanguage = language;
        Config.lang = Localization.data.currentLanguage;
        i18n.activate(language);
        Localization.instance.setState({});
    }

    render({children}) {
        return <I18nProvider i18n={i18n}>
            {children}
        </I18nProvider>;
    }
}

/*
 * Se non sto aprendo una pagina popup cerco il default del browser
 * altrimenti mi fido della selezione che arriva dalla pagina principale
 */
if (!!window.opener && !!window.opener.i18n && !!window.opener.i18n._language) {
    Config.defaultLanguage = window.opener.i18n._language;
} else {
    const languages = [navigator.language, ...(navigator.languages || []), Config.defaultLanguage];
    Config.defaultLanguage = languages.find(lang => catalogs[lang]);
}

if (!!window.location.search) {
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('lang') && !!catalogs[urlParams.get('lang')]) {
        const initialLang = urlParams.get('lang');
        Localization.data.currentLanguage = initialLang;
        Config.lang = initialLang;
    }
}


i18n.activate(Localization.data.currentLanguage);

export default Localization;
